import { ChangeDetectorRef, Component, Inject, InjectionToken, Injector, OnInit } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { ModuleType } from '@fi-shared/types/module-type';
import { ILightWeightObject } from '@fi-shared/models';
import { fiDoesLightWeightObjectHaveChildren } from '@fi-shared/utils/fi-does-light-weight-object-have-children';
import { FiDropdownItemDisabledFn } from '@fi-shared/fi-select-search/fi-select-search';
import { fiHasAccessToApplicationType } from '@fi-shared/utils';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiTagsService } from '@fi-shared/fi-shared-services';
import { ILightWeightTag } from '@fi-shared/fi-tag2/fi-tag2';

export type TDataFieldEditTagsComponent_Settings = {
    tagsDataSource: () => PromiseLike<ILightWeightTag[]>;
    isDisabledFunc?: () => boolean;
};

export const DataFieldEditTagsComponent_Settings = new InjectionToken('DataFieldEditTagsComponent_Settings');

@Component({
    selector: 'data-field-edit-tags',
    templateUrl: './tags.component.html',
    standalone: false,
})
export class DataFieldEditTagsComponent extends DataFieldEditBase implements OnInit {
    ModuleType = ModuleType;
    availableTags: ILightWeightTag[] = [];
    //optionDisabledFn = fiDoesLightWeightObjectHaveChildren;

    // https://chainformation.atlassian.net/browse/FI-6016
    // allow tags select on any level
    optionDisabledFn = (item: ILightWeightTag, array: ILightWeightTag[]) => item.IsDisabled; // user has no access to tag
    hasRightsToAddTags: boolean;

    constructor(
        injector: Injector,
        private fiUserDataService: FiUserDataService,
        private fiTagsService: FiTagsService,
        private cdr: ChangeDetectorRef,
        @Inject(DataFieldEditTagsComponent_Settings) public settings: TDataFieldEditTagsComponent_Settings,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.settings.tagsDataSource().then((result) => {
            this.availableTags = result;
        });

        const userData = this.fiUserDataService.getUserData();
        this.hasRightsToAddTags = fiHasAccessToApplicationType(
            ApplicationSettingsType.Tag,
            AccessRightType.Write,
            userData.ModuleAccessRights,
        );
    }

    /*isTagsDisabledFn: FiDropdownItemDisabledFn<ILightWeightObject> = (item: ILightWeightObject, allItems: ILightWeightObject[]) => {
        if (this.optionDisabledFn(item, allItems))
            return true;
        if (this.settings && this.settings.isDisabledFunc)
            return this.settings.isDisabledFunc();
        return false;
    }*/

    addNewTag(tagName: string): void {
        this.fiTagsService.saveTag(this.fiTagsService.getNewTagModel(tagName, ModuleType.Core)).then((id: number) => {
            const newTag: ILightWeightTag = {
                Id: id,
                Name: tagName,
                ParentId: null,
                Level: 0,
            };

            this.availableTags.push(newTag);
            this.dataFieldObject.TagIds = [...this.dataFieldObject.TagIds, newTag.Id];
            this.cdr.markForCheck();
        });
    }
}
